import {
  Component,
  createNgModule,
  createNgModuleRef,
  ElementRef,
  HostListener,
  Inject,
  Injector,
  NgModuleRef,
  PLATFORM_ID,
  Type,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { FormGroup, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatButtonToggle } from '@angular/material/button-toggle';
import { priceValidator } from '../amount.validator';
import { BasePageComponentWithDialogs } from 'src/app/components/base-page/base-page.component';
import { PaymentList, PaymentMethod, PriceValues } from 'src/app/services/payment/methods/methods.models';
import { DepositService } from 'src/app/services/payment/deposit/deposit.service';
import { filter, switchMap, take, takeUntil } from 'rxjs/operators';
import { BonusListService } from 'src/app/services/payment/bonus/bonus-list.service';
import { BonusInfo } from 'src/app/services/payment/bonus/bonus.models';
import { BalanceStatusService } from 'src/app/services/wallet/balance-status.service';
import {
  PAYMENT_METHOD_PROVIDER_ARI,
  PAYMENT_METHOD_PROVIDER_BACKOFFICE,
  PAYMENT_METHOD_PROVIDER_PAYMENTIQ,
  PaymentListService
} from 'src/app/services/payment/methods/payment-list.service';
import { LoaderService } from 'src/app/services/utils/loader/loader.service';
import { MatDialog } from '@angular/material/dialog';
import { DetectDeviceService } from 'src/app/services/utils/detect-device.service';
import { DomSanitizer, SafeHtml, SafeResourceUrl } from '@angular/platform-browser';
import { LoginStatusService } from 'src/app/services/auth/login/login-status.service';
import { HOST_NAME, LICENCE } from 'src/app/global.tokens';
import { FormFillerFactory } from './form-fillers/form-filler.factory';
import { DialogClosePreviousUrl } from 'src/app/services/utils/dialog-close-previouse-url.service';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import {
  depositTrx,
  editProfileTrx,
  paymentApayTrx,
  paymentTrx,
  paymentUpiFastTrx,
  paymentUpiP2pTrx
} from 'src/app/router-translation.labels';
import { forkJoin, map, Subject, Subscription, timer } from 'rxjs';
import { TranslationConfig } from 'src/app/utils/translate-config';
import { PaymentIqService } from 'src/app/services/payment/methods/paymentiq.service';
import { SavedDepositState } from '../../../../services/profile/edit-profile.models';
import { SavedGameState } from 'src/app/services/profile/game-state.models';
import { GameStateService } from 'src/app/services/profile/game-state.service';
import { MinimizeSiteService } from 'src/app/services/utils/hide-footer.service';
import { environment } from 'src/environments/environment';
import { applyServerErrors } from 'src/app/components/auth/signup/utils/apply-server-validators';
import { UserFullInfoService } from 'src/app/services/auth/check-session/user-full-info.service';
import { DepositStateService } from 'src/app/services/profile/deposit-state.service';
import { UserFullInfo } from 'src/app/services/auth/login/login.models';
import { LicenceService } from 'src/app/services/utils/licence.service';
import { PendingWithdrawalService } from 'src/app/services/payment/withdrawal/pending-withdrawal.service';
import { PendingWithdrawalList } from 'src/app/services/payment/withdrawal/withdrawal.models';
import { CancelWithdrawalService } from 'src/app/services/payment/withdrawal/cancel-withdrawal.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { isPlatformServer, LocationStrategy } from '@angular/common';
import { LogExceptionService } from 'src/app/services/utils/log-exception';
import { PraxisHpfComponent } from '../praxis-hpf/praxis-hpf.component';


interface Teaser {
  msg: string;
  countDown: {
    minutes: string,
    seconds: string
  };
}

export const DELETE_CARD_WARNING: string = $localize`:@@deleteCardMsg: This payment method will be deleted from your account. Are you sure?`;
const confirmationMsg: string = $localize`:@@pendingWithdrawalConfirmationMsg:Are you sure you want to cancel the withdrawal?`;

// const successMsg: string = $localize`:@@pendingWithdrawalSuccessMsg:Your withdrawal request has been successfully cancelled. Your funds are now available in your wallet. `;

@Component({
  selector: 'app-main-deposit',
  templateUrl: './main-deposit.component.html',
  styleUrls: ['./main-deposit.component.scss'],
  animations: [
    trigger('disappear', [
      state('in', style({ opacity: 1, height: '*', transform: 'scale(1)' })),
      state('out', style({ opacity: 0, height: 0, transform: 'scale(0)' })),
      transition('in => out', [
        animate('0.5s ease-in')
      ])
    ])
  ]
})
export class MainDepositComponent extends BasePageComponentWithDialogs {

  depositForm: UntypedFormGroup;
  @ViewChild('pendingWithdrawal') pendingWithdrawal: ElementRef;
  @ViewChild('pendingWithdrawalValue') pendingWithdrawalValue: ElementRef;

  cancelWithdrawalForm = this.formBuilder.group({
    payment_id: ['', []],
  });

  additionalField = [];
  hasAdditionalInput: boolean = false;

  minPrice: number = 0;
  maxPrice: number = 0;

  defaultPrices: PriceValues;
  //  = [{ value: 0, label: '10' }, { value: 200, label: '200' }, { value: 200, label: '3000' }, { value: 0, label: '50' }, { value: 0, label: '100' }];
  _activeToggle: MatButtonToggle;
  selectedPaymentMethod: PaymentMethod;
  _formSubmitted: boolean = false;

  isBonusesReady: boolean = false;
  bonusList: BonusInfo[];
  paymentList: PaymentList;
  selectedBonus: BonusInfo;
  currency: string;
  descritpion: SafeHtml;
  isFullDataDepositAllowed: boolean = true;
  isClosable: boolean;
  isDisplayPaymentLink: boolean = false;
  paymentLink: SafeResourceUrl;
  isComponentReady: boolean = false;
  timerValue: number;
  paymentLinkTimer$: Subscription;
  selectPayment: boolean = false;
  selectBonusTriggered: boolean = false;
  @ViewChild('paymentlinkelement') paymentLinkElement: ElementRef;
  @ViewChild('praxishpf', { static: false }) praxisHpfComponent: PraxisHpfComponent;
  paymentIQMethodProvider: string = PAYMENT_METHOD_PROVIDER_PAYMENTIQ;
  editProfile: string = this.translationConfig.getTranslation(editProfileTrx);
  paymentIqAdditionalFieldsValue: Subject<UntypedFormGroup> = new Subject();
  // isRedirectToIframePayment: boolean = false;
  paymentIQGenericFieldsError = $localize`:@@paymentIqWrongCard:Plese enter correct values for all fields.`;
  public isLoading = true;
  isExtendedPaymentFlow: boolean = false;
  isCustomUIPaymentFlow: boolean = false;
  transactionCustomUIFinished: boolean = false;
  public currentAmount: number = 0;
  showPaymentiq: boolean = false;
  public teaser: Teaser;
  hasTeaserMsg: boolean = false;
  hasTeaserCountDown: boolean = false;
  isOpen: boolean = false;
  scrollPosition = 0;
  userInfo: UserFullInfo;
  cryptoSelectedValue: any;
  @ViewChild('customuiflow', { static: false, read: ViewContainerRef })
  public viewRef: ViewContainerRef;
  protected isShowPaymentIqModulePlaceholder = true;
  pendingList: PendingWithdrawalList;
  successMsg: string;
  private paymentIqComponentInstance: any;
  private isSavedStatedLoaded = false;
  private gameState: SavedGameState = null;
  routingState:any = null;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private depositService: DepositService,
    private bonusListService: BonusListService,
    private ballanceStatusService: BalanceStatusService,
    private paymentListService: PaymentListService,
    private loaderService: LoaderService,
    private sanitizer: DomSanitizer,
    private minimizeFotterService: MinimizeSiteService,
    protected translationConfig: TranslationConfig,
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private paymentIqService: PaymentIqService,
    private loginStatusService: LoginStatusService,
    public detectDeviceService: DetectDeviceService,
    private returnUrlService: DialogClosePreviousUrl,
    private userFullInfoService: UserFullInfoService,
    private _injector: Injector,
    @Inject(LICENCE) public license: string,
    @Inject(HOST_NAME) public hostname: string,
    @Inject(PLATFORM_ID) public platformId: string,
    private gameStateService: GameStateService,
    private depositStateService: DepositStateService,
    protected licenceService: LicenceService,
    private pendingListService: PendingWithdrawalService,
    private cancelWithdrawalService: CancelWithdrawalService,
    private location: LocationStrategy
  ) {
    super(dialog, detectDeviceService);
  }

  private _paymentiqRef: ViewContainerRef;

  get paymentiqRef(): ViewContainerRef {
    return this._paymentiqRef;
  }

  @ViewChild('paymentiq', { static: false, read: ViewContainerRef })
  set paymentiqRef(ref: ViewContainerRef) {
    this._paymentiqRef = ref;
    //console.log('* Setter - paymentiqRef set:', !!ref);
    if (ref) {
      //console.log('* Setter - Initializing PaymentiqAdditionalFieldsComponent...');
      if (!isPlatformServer(this.platformId)) {
        import('../../../../modules/paymentiq-additional-fields/paymentiq-additional-fields.module').then((importedFile) => {
          const componentToOpen =
            importedFile.PaymentiqAdditionalFieldsDynamicModule.components.dynamicComponent;
          //console.log('* Setter - Component to open:', !!componentToOpen);
          this._openLazyLoadedPaymentIqComponent(importedFile, componentToOpen);
        });
      }
    }
  }

  selectPaymentClick() {
    this.selectPayment = true;
    this.scrollPosition = window.scrollY;
  }

  override ngOnInit(): void {
    this.routingState = history?.state||{};
    this.generateList();
    this.depositStateService.refreshDepositState();
    this.minimizeFotterService.minimizeToolbar();
    this.isDesktop = this.detectDeviceService.isDesktop();
    this.successMsg = this.isDesktop
      ? $localize`:@@pendingWithdrawalSuccessMsg:Your withdrawal request has been successfully cancelled. Your funds are now available in your wallet.`
      : $localize`:@@walletFundsAvailableMsg:Your funds are available in your Bison wallet.`;
    this.isLoading = true;
    this.isExtendedPaymentFlow = false;
    let gameName = this.route.snapshot.paramMap.get('gameName');
    let gameDepositTimestamp = parseInt(this.route.snapshot.paramMap.get('gameDepositTimestamp'));
    if (gameName && gameDepositTimestamp && !isNaN(gameDepositTimestamp)) {
      this.gameState = {
        name: gameName,
        timestamp: gameDepositTimestamp
      };
    }
    // this.loaderService.show();
    this.isClosable = !!this.route.snapshot.queryParamMap.get('isclosable');

    this.depositForm = this.formBuilder.group({
      amount: [100, [Validators.required]],
      payment_id: ['', [Validators.required]],
      bonus_id: [0, []],
      code_id: ['', []],
      freespin_code: ['', []],
    });

    this.router.events.pipe(takeUntil(this.unsubscribe)).subscribe((event) => {
      if (event instanceof NavigationStart) {
        if (event.url === `/${this.translationConfig.getTranslation(paymentTrx)}/${this.translationConfig.getTranslation(depositTrx)}`) {
          this.isExtendedPaymentFlow = false;
        }
      }
    });

    this.loginStatusService.getLoginPartialStatus().pipe(take(1),
      switchMap(() => {
        return this.userFullInfoService.requestFullInfo(true).pipe(take(1));
      })
    ).subscribe(resp => {
      this.isFullDataDepositAllowed = resp.is_full_data;
      this.userInfo = resp;
      forkJoin({
        // here pay list income
        paymentResp: this.paymentListService.fetchPayment(resp.country || 'en').pipe(
          filter(resp => resp?.length !== 0),
          take(1)),
        // here bonus list income
        bonusResp: this.bonusListService.fetchData().pipe(
          filter(resp => resp?.length !== 0),
          take(1))
      }
      ).subscribe((resp) => {
        // this.loaderService.hide();
        // this.selectPaymentMethod(resp[0], false);

        // assign lists
        this.paymentList = resp.paymentResp;



        this.bonusList = resp.bonusResp;

        const routerState = this.location.getState() as any;

        if (routerState) {
          const preselectedBonusId = routerState.bonus;
          this.selectedBonus = this.bonusList.find(bonus => bonus.externalId === preselectedBonusId);
        }
        this.isBonusesReady = true;
        this.hideSpinner();

        this.loadState(resp.paymentResp[0]);  // <- load state
      }, (error => {
        this.loaderService.hide();
      }));

      this.ballanceStatusService.getBalanceInfoStatus().pipe(takeUntil(this.unsubscribe)).subscribe(resp => {
        this.currency = resp.currency;
        if (!!this.currency && (!this.defaultPrices || this.defaultPrices?.length === 0)) {
          this.defaultPrices = !!environment.defaultDepositValues[this.currency.toUpperCase()] ? environment.defaultDepositValues[this.currency.toUpperCase()].map(item => {
            return { label: `${item} ${this.currency.toUpperCase()}`, value: item };
          }) : [];
        }
      });
    });
  }

  generateList() {
    this.pendingListService.getList().pipe(take(1)).subscribe({
      next: (resp) => {
        this.pendingList = resp;
      },
      error: (error) => {
        console.log(error);
        // this.openErrorDialog(error)
      }
    }
    );
  }

  @HostListener('document:click', ['$event'])
  handleClickOutside(event: Event) {
    const element = event.target as HTMLElement;
    if (this.isOpen && !this.pendingWithdrawal?.nativeElement.contains(element) && !this.pendingWithdrawalValue?.nativeElement.contains(element) && !this.dialogOpened) {
      this.isOpen = false;
    }
  }

  toggleOpen(event: Event) {
    // event.stopPropagation();
    const element = event.target as HTMLElement;
    if (this.isOpen && this.pendingWithdrawalValue?.nativeElement.contains(element)) {
      return;
    }
    this.isOpen = !this.isOpen;
  }

  removeItem(index: number) {
    this.pendingList.results.splice(index, 1);
    this.generateList();
  }

  checkConfirmCancel(paymentId: number) {
    this.openConfirmDialog(confirmationMsg, paymentId, this.confirm);
  }

  checkConfirmCancels(item) {
    item.state = 'out';
    const index = this.pendingList.results.findIndex((i: any) => i.id === item.id);
    if (index !== -1) {
      setTimeout(() => this.removeItem(index), 700);
    }
  }

  override confirm(data: any) {
    console.log('confirmation data', data);
    if (data.cancel_method === 'paymentiq') {
      this.paymentIqService.cancelPandingWithdrawal(data.ext_transaction_id).pipe(take(1)).subscribe((resp) => {
        if (resp.success) {
          const successImg = this.licenceService.getKey('pending-withdrawal');
          this.openSuccessDialog(this.successMsg, 'Success!', () => this.callList(data), null, successImg);
        } else {
          this.openErrorDialog();
        }
      });
    } else {
      this.cancelWithdrawalForm.get('payment_id').setValue(data.id);
      this.cancelWithdrawalService.cancelWithdrawal(this.cancelWithdrawalForm).pipe(takeUntil(this.unsubscribe)).subscribe(
        resp => {
          console.log(resp);
          const successImg = this.licenceService.getKey('pending-withdrawal');
          this.openSuccessDialog(this.successMsg, 'Success!', () => this.callList(data), null, successImg);
          // this.generateList()
        },
        error => {
          this.openErrorDialog(error.error?.detail);
          this.generateList();
        }
      );
    }
  }

  callList(data) {
    this.checkConfirmCancels(data);
  }

  hideSpinner() {
    this.isLoading = false;
  }

  confirms(accountToDelete: string) {
    this.paymentIqComponentInstance.confirmAccountDelete();
  }

  onAccountDeleteAttempt(accountToDelete: string) {
    this.openConfirmDialog(DELETE_CARD_WARNING, accountToDelete, () => this.confirms);
  }

  createDepositForm(selectPaymentMethodInput: PaymentMethod) {
    this.isCustomUIPaymentFlow = false;
    this.transactionCustomUIFinished = false;
    this.isDisplayPaymentLink = false;

    const isBackofficeOrAri = [
      PAYMENT_METHOD_PROVIDER_BACKOFFICE,
      PAYMENT_METHOD_PROVIDER_ARI,
    ].includes(selectPaymentMethodInput.paymentMethodProvider);

    if (isBackofficeOrAri) {
      this.setupFormForBackofficeOrAri(selectPaymentMethodInput);
    } else if (selectPaymentMethodInput.paymentMethodProvider === PAYMENT_METHOD_PROVIDER_PAYMENTIQ) {
      this.setupFormForPaymentIQ(selectPaymentMethodInput);
    }
  }

  private setupFormForBackofficeOrAri(selectPaymentMethodInput: PaymentMethod) {
    this.depositService.getDepositDetails(selectPaymentMethodInput.id.toString())
      .pipe(take(1))
      .subscribe(resp => {
        this.initializeForm(selectPaymentMethodInput);

        const fields = resp.fields.filter(item => item.name !== 'amount');
        this.addFieldsToForm(fields);

        this.additionalField = fields;
        this.hasAdditionalInput = fields.some(item => ['input', 'select'].includes(item.type));

        this.setFormValidatorsAndDefaults(selectPaymentMethodInput, resp.name);

        if (!this.isComponentReady) {
          this.isComponentReady = true;
        }

        switch (this.selectedPaymentMethod.systemName.toUpperCase()) {
          case "UPI MANUAL":
            this.isCustomUIPaymentFlow = true;
            import('../custom-payment-flows/apay.module').then((importedFile) => {
              const componentToOpen =
                importedFile.ApayModule.components.upiManualDynamic;
              this._openLazyLoadedComponent(importedFile, componentToOpen, { 'depositForm': this.depositForm });
            });
            break;
        }
        this.loaderService.hide();
        this.hideSpinner();
      });
  }

  private setupFormForPaymentIQ(selectPaymentMethodInput: PaymentMethod) {
    this.initializeForm(selectPaymentMethodInput);

    if (selectPaymentMethodInput.paymentIqAdditionalFields) {
      this.addPaymentIQFieldsToForm(selectPaymentMethodInput.paymentIqAdditionalFields);
    }

    this.setFormValidatorsAndDefaults(selectPaymentMethodInput, selectPaymentMethodInput.name.toLowerCase());

    if (!this.isComponentReady) {
      this.isComponentReady = true;
    }

    this.hideSpinner();
  }

  private initializeForm(selectPaymentMethodInput: PaymentMethod) {
    const currentAmount = this.depositForm?.get('amount')?.value || 0;
    this.currentAmount = currentAmount;
    this.additionalField = [];

    this.depositForm = this.formBuilder.group({
      amount: [currentAmount, [Validators.required]],
      payment_id: ['', [Validators.required]],
      bonus_id: [0, []],
      code_id: ['', []],
      freespin_code: ['', []],
    });
  }

  private addFieldsToForm(fields: any[]) {
    fields.forEach(field => {
      const value = field.choices?.find(item => item.selected)?.value?.toString() || '';
      const validators = field.type !== 'select' ? Validators.required : undefined;
      this.depositForm.addControl(field.name, new UntypedFormControl(value, validators));
    });
  }

  private addPaymentIQFieldsToForm(fields: any[]) {
    fields.forEach(field => {
      const value = field.value || '';
      const validators: any[] = [];
      if (field.type !== 'select') {
        validators.push(Validators.required);
      }
      if (field.name === 'email') {
        validators.push(Validators.email);
      }
      this.depositForm.addControl(field.name, new UntypedFormControl(value, validators));

      if (['input', 'select'].includes(field.type)) {
        this.hasAdditionalInput = true;
      }

      if (field.type !== 'hidden') {
        this.additionalField.push(field);
      }

      if (field.selections?.length) {
        this.cryptoSelectedValue = field.selections[0].name;
        this.depositForm.get(field.name).setValue(field.selections[0].value);
      } else if (field.choices?.length) {
        this.cryptoSelectedValue = field.choices[0].display_name;
      }
    });
  }

  private setFormValidatorsAndDefaults(selectPaymentMethodInput: PaymentMethod, fillerName: string) {
    const validators = [
      Validators.required,
      priceValidator(selectPaymentMethodInput.limits.minimum, selectPaymentMethodInput.limits.maximum),
    ];
    this.depositForm.get('amount').setValidators(validators);
    this.depositForm.get('payment_id').setValue(selectPaymentMethodInput.id);

    FormFillerFactory.getFiller(fillerName).fillForm(this.depositForm, this.userInfo);

    if (this.defaultPrices?.length && (this.currentAmount === 0 || this.currentAmount < selectPaymentMethodInput.limits.minimum)) {
      this.selectPriceValue(this.defaultPrices[1].value);
    }

    if (this.selectedBonus) {
      this.selectBonus(this.selectedBonus);
    }

    this.depositForm.enable();
  }

  private compareValidator() {
    const BonusMinPrice = Number(this.selectedBonus?.min_deposit_amount);
    const PaymentMinPrice = Number(this.selectedPaymentMethod?.limits?.minimum);
    const CompareMinPrice = BonusMinPrice > PaymentMinPrice ? BonusMinPrice : PaymentMinPrice;
    if(CompareMinPrice) {
      this.minPrice = CompareMinPrice;
      const validators = [
        Validators.required,
        priceValidator(this.minPrice, this.maxPrice),
      ];
      this.depositForm.get('amount').setValidators(validators);
    }
    if(BonusMinPrice > PaymentMinPrice) {
      const minDepositMsg: string = $localize`:@@minDepositMsg:To receive this bonus you must deposit at least ${this.minPrice.toFixed(2)} ${this.currency.toUpperCase()}`;
      const minDepositTitle: string = $localize`:@@minDepositTitle:Minimum Deposit Changed`;
      this.openErrorDialog(minDepositMsg, minDepositTitle)
    }
  }

  clickable(data: any) {
    this.cryptoSelectedValue = data;
  }

  onPaymentLinkClick() {
    this.paymentLinkTimer$?.unsubscribe();
    this.isDisplayPaymentLink = false;
  }

  onSubmit(depositForm: FormGroup) {
    if (this._formSubmitted || this.isLoading) {
      return;
    }
    this.gameStateService.addGameState(this.gameState);
    this._formSubmitted = true;
    this.resetFormSubmittedState(5000);

    if (this.selectedPaymentMethod.paymentMethodProvider === PAYMENT_METHOD_PROVIDER_BACKOFFICE) {
      if (!this.depositForm.valid) {
        return;
      }
      this.handleBackofficePayment(depositForm);
    } else if (this.selectedPaymentMethod.paymentMethodProvider === PAYMENT_METHOD_PROVIDER_PAYMENTIQ) {
      this.handlePaymentIQPayment(depositForm);
    }
  }

  selectPriceValue($event) {
    this.loaderService.hide();
    this.depositForm.get('amount').setValue($event);
    this.buttonEnable();
    this.currentAmount = $event;
    // this.saveState();
  }

  selectTeaserValue($event) {
    this.teaser = $event;

    if (this.teaser.msg && this.teaser.msg?.length > 0) {
      this.hasTeaserMsg = true;
    }

    if (this.teaser.countDown && this.teaser.countDown.minutes && this.teaser.countDown.seconds) {
      this.hasTeaserCountDown = true;
    }
  }

  selectPaymentMethod(selectPaymentMethodInput: PaymentMethod, shouldSaveState = true) {
    this.isLoading = true;
    this.selectPayment = false;
    this.selectedPaymentMethod = selectPaymentMethodInput;
    this.showPaymentiq = (this.selectedPaymentMethod?.paymentIqAccounts?.length > 0) || (this.selectedPaymentMethod?.addPaymentIqHostedFields);

    // this.isLoading = this.showPaymentiq;
    this.minPrice = selectPaymentMethodInput.limits?.minimum || 0;
    this.maxPrice = selectPaymentMethodInput.limits?.maximum || 10000;
    this.descritpion = null;

    if (selectPaymentMethodInput.description) {
      this.descritpion = selectPaymentMethodInput?.description['changingThisBreaksApplicationSecurity'] === '<p></p>' ? null : selectPaymentMethodInput.description;
    }

    if (!this.defaultPrices) {
      this.defaultPrices = selectPaymentMethodInput.amounts_select;
    }

    this.createDepositForm(selectPaymentMethodInput);

    if (shouldSaveState) {
      // this.saveState();
    }
    this.buttonEnable();

    window.scrollTo(0, this.scrollPosition);
  }

  selectBonus(bonus: BonusInfo) {
    this.selectBonusTriggered = false;
    if (bonus.externalId !== '0') {
      this.selectedBonus = bonus;
      if (bonus.isFreeSpin) {
        this.depositForm.get('freespin_code').setValue(bonus.externalId);
      } else {
        this.depositForm.get('bonus_id').setValue(bonus.externalId);
      }
      // this.saveState();
    } else {
      this.selectedBonus = null;
      this.depositForm.get('bonus_id').setValue(null);
    }
    this.buttonEnable();
    this.compareValidator();
  }

  amountChange(value) {
    if (this._activeToggle) {
      this._activeToggle.checked = false;
    }
    this.buttonEnable();
    this.currentAmount = value;
    // this.saveState();
  }

  buttonEnable() {
    if (this._formSubmitted)
      this._formSubmitted = false;
  }

  redirectProfile() {
    this.route.url.pipe(takeUntil(this.unsubscribe)).subscribe(url => {
      this.returnUrlService.setUrl([this.translationConfig.getTranslation(paymentTrx), this.translationConfig.getTranslation(depositTrx)]);
      this.router.navigate(['', editProfileTrx]);
    });
  }

  override ngOnDestroy(): void {
    this.minimizeFotterService.restoreToolbar();
    this.loaderService.hide();
    this.saveState();
    super.ngOnDestroy();
  }

  closeCustomUiFlow() {
    this.isExtendedPaymentFlow = false;
    this.transactionCustomUIFinished = true;
    // this.router.navigate(['']);
  }

  private handleBackofficePayment(depositForm: FormGroup) {
    if (this.selectedPaymentMethod.addPraxisHpf) {
      this.praxisHpfComponent.getCardDetails().then((card) => {
        console.log(card)
      });
    }
    else {

      this.depositService.postDeposit(this.depositForm).pipe(takeUntil(this.unsubscribe)).subscribe(
        resp => this.processBackofficeResponse(resp),
        error => this.handlePaymentError(error),
        () => {
          this._formSubmitted = false;
          this.resetState();
        }
      );
    }
  }

  private processBackofficeResponse(resp: any) {
    const methodName = this.selectedPaymentMethod.name;
    const isExtendedFlow = ['UPI P2P', 'A-PAY PHONEPE', 'A-PAY PAYTM', 'UPI FAST V', 'UPI FAST'].includes(methodName);
    this.isExtendedPaymentFlow = true;
    if (isExtendedFlow) {
      this.isExtendedPaymentFlow = true;
      const route = methodName.includes('FAST') ? paymentUpiFastTrx : paymentUpiP2pTrx;
      this.router.navigate(['', 'payment', 'deposit', paymentApayTrx, route], {
        state: {
          method: this.selectedPaymentMethod,
          resp: resp
        }
      });
    } else {
      this.handleDefaultPayment(resp);
    }

    this.loaderService.hide();
  }

  private handleDefaultPayment(resp: any) {
    const paymentLink = this.sanitizer.bypassSecurityTrustResourceUrl(resp.payment_link);
    this.paymentLink = paymentLink;

    if (this.selectedPaymentMethod.openNewTab) {
      this.displayPaymentLinkWithTimer(resp.payment_link);
    } else if (this.selectedPaymentMethod.systemName == 'UPI Manual') {
      this.closeCustomUiFlow();
    } else {
      window.location.href = resp.payment_link;
    }

    this.isDisplayPaymentLink = true;
  }

  private displayPaymentLinkWithTimer(paymentLink: string) {
    const countdownStart = 5;

    this.paymentLinkTimer$ = timer(0, 1000).pipe(
      takeUntil(this.unsubscribe),
      map(i => countdownStart - i),
      take(countdownStart + 1)
    ).subscribe(value => {
      this.timerValue = value;
      if (value === 0) {
        window.location.href = paymentLink;
      }
    });
  }

  private handlePaymentIQPayment(depositForm: FormGroup) {
    const paymentIqSubmit = (resp: any) => {
      const processedResp = this.paymentIqService.processResponse(resp);
      this.loaderService.hide();

      if (processedResp.isError) {
        this.openErrorDialog(processedResp.errorMsg);
        this._formSubmitted = false;
      }
    };

    if (this.selectedPaymentMethod.addPaymentIqHostedFields) {
      this.paymentIqComponentInstance?.getCardDetails().then(() => {
        this.paymentIqAdditionalFieldsValue.pipe(takeUntil(this.unsubscribe), take(1)).subscribe(formData => {
          this.loaderService.hide();
          // if (!formData) {
          //   try {
          //     this.logExceptionService.logException("Formdata empty", { username: JSON.stringify(this.userInfo.id), methodname: JSON.stringify(this.selectedPaymentMethod.id), formData: JSON.stringify(formData?.value) }).pipe(takeUntil(this.unsubscribe)).subscribe(() => {
          //       console.log("logged added remotely")
          //     })
          //   } catch (e) {
          //     console.log("error reporting sentry")
          //   }
          // }
          if (!this.depositForm.valid) {
            this.openErrorDialog(this.paymentIQGenericFieldsError);
            this._formSubmitted = false;
            return;
          }
          else {
            // if (this.selectedPaymentMethod.id === "CREDITCARD") {

            //   if (this.selectedPaymentMethod?.paymentIqAccounts?.length > 0 && !formData.get("accountId")) {
            //     try {
            //       this.logExceptionService.logException("Error credit card", { username: JSON.stringify(this.userInfo.id), methodname: JSON.stringify(this.selectedPaymentMethod.id), formData: JSON.stringify(formData?.value) }).pipe(takeUntil(this.unsubscribe)).subscribe(() => {
            //         console.log("logged added remotely")
            //       })
            //     } catch (e) {
            //       console.log("error reporting sentry")
            //     }
            //   }
            // }
            if(!!formData.errors) {
              const errorMsg: any = formData.errors;
              this.openErrorDialog(errorMsg);
              return;
            }
            const controls = formData.controls;
            for (const [key, value] of Object.entries(controls)) {
              this.depositForm.removeControl(key);
              this.depositForm.addControl(key, value);
            }

            this.paymentIqService.submitTransaction(this.depositForm, this.selectedPaymentMethod).subscribe(paymentIqSubmit);
          }

        });
      });
    } else {
      if (!this.depositForm.valid) {
        return;
      }
      const account = this.paymentIqComponentInstance?.getAccountName();
      if (!!account && account !== "") {
        this.depositForm.removeControl('accountId');
        this.depositForm.addControl('accountId', new UntypedFormControl(account, [Validators.required]));

      }
      this.paymentIqService.submitTransaction(depositForm, this.selectedPaymentMethod).subscribe(resp => {
        if (!resp.errors) {
          this.resetState();
        }
        paymentIqSubmit(resp);
      });
    }
  }

  private handlePaymentError(error: any) {
    this._formSubmitted = false;

    const hasServerErrors = applyServerErrors(error, this.depositForm);
    if (!hasServerErrors) {
      const errorMsg = error.errors?.limit_exceeded.trim() || error.error?.detail || error.error?.error;
      gtag('event', 'exception', {
        description: errorMsg,
        fatal: false
      });
      this.openErrorDialog(errorMsg || undefined);
    }

    this.loaderService.hide();
  }

  private resetFormSubmittedState(delayMs: number): void {
    setTimeout(() => {
      this._formSubmitted = false;
    }, delayMs);
  }

  private resetState() {
    this.depositStateService.addDepositState(null);
  }

  private saveState() {
    if (!this.isSavedStatedLoaded) {
      return;
    }
    if (this.selectedPaymentMethod) {
      const state: SavedDepositState = {
        amount: this.depositForm.get('amount').value,
        payment_id: this.selectedPaymentMethod?.id?.toString(),
        bonus_id: this.depositForm.get('bonus_id').value,
        code_id: this.depositForm.get('code_id').value,
        freespin_code: this.depositForm.get('freespin_code').value,
        isFreeSpin: this.selectedBonus?.isFreeSpin ?? false,
      };

      this.depositStateService.addDepositState(state);
    }
  }

  private loadState(defaultMethod: PaymentMethod) {
    this.depositStateService.isDataLodaed.next(false);
    const defaultSelectBonusInfo = this.bonusList.find(bonus=> bonus.name === this.routingState?.name);
    this.depositStateService.getLastDepositState().pipe(takeUntil(this.unsubscribe)).subscribe((state) => {
      if (!!state) {
        this.depositForm.get('amount').setValue(state.amount);
        this.depositForm.get('payment_id').setValue(state.payment_id);
        this.depositForm.get('code_id').setValue(state.code_id);
        this.depositForm.get('freespin_code').setValue(state.freespin_code);

        if (!this.selectedBonus && +state.bonus_id !== 0) {
          this.depositForm.get('bonus_id').setValue(state.bonus_id);
          const bonusInfo = this.bonusList.find(bonus => bonus.externalId === state.bonus_id);
          if (bonusInfo != null && !defaultSelectBonusInfo) {
            this.selectBonus(bonusInfo);
          }
        }

        const paymentMethod = this.paymentList.find((method) => method.id.toString() === state.payment_id);
        if (paymentMethod != null) {
          this.selectPaymentMethod(paymentMethod, false);
        } else {
          this.selectPaymentMethod(defaultMethod, false);
        }
      } else {
        this.selectPaymentMethod(defaultMethod, false);
        this.isSavedStatedLoaded = false;
      }
      this.isSavedStatedLoaded = true;
    });

    this.isSavedStatedLoaded = true;

    if(defaultSelectBonusInfo){
      this.selectBonus(defaultSelectBonusInfo);
    }
  }

  private _openLazyLoadedComponent<T, K>(
    importedFile: T,
    componentToOpen: Type<K>,
    inputs: any
  ): void {
    const module: Type<T> = (<any>importedFile)[Object.keys(importedFile)[0]];
    const moduleRef: NgModuleRef<T> = createNgModuleRef(module, this._injector);
    let componentRef = this.viewRef.createComponent(componentToOpen, { ngModuleRef: moduleRef });
    Object.keys(inputs).forEach((key) => {
      componentRef.setInput(key, inputs[key]);
    });
  }

  private _openLazyLoadedPaymentIqComponent<T>(
    importedFile: T,
    componentToOpen: Type<any>
  ): void {
    //console.log('* _openLazyLoadedPaymentIqComponent - Starting component creation');
    if (!!this.paymentIqComponentInstance) {
      //console.log('* _openLazyLoadedPaymentIqComponent - Component already initialized');
      return;
    }
    //console.log('* _openLazyLoadedPaymentIqComponent - Proceeding with component creation');
    this.isShowPaymentIqModulePlaceholder = false;
    const module: Type<T> = (importedFile as any)[Object.keys(importedFile)[0]];
    const moduleRef: NgModuleRef<T> = createNgModule(module, this._injector);
    const componentRef = this.paymentiqRef.createComponent(componentToOpen, { ngModuleRef: moduleRef });

    this.paymentIqComponentInstance = componentRef.instance;

    //console.log('* _openLazyLoadedPaymentIqComponent - Component created:', this.paymentIqComponentInstance);

    this.paymentIqComponentInstance.parentForm = this.depositForm;
    this.paymentIqComponentInstance.paymentIqAdditionalFieldsValueInput = this.paymentIqAdditionalFieldsValue;
    this.paymentIqComponentInstance.methodInfo = this.selectedPaymentMethod;
    this.paymentIqComponentInstance.isDeposit = true;

    this.paymentIqComponentInstance.fieldsInitialized.subscribe(() => this.hideSpinner());

    this.paymentIqComponentInstance.accountDeleteAttempt.subscribe((event) => this.onAccountDeleteAttempt(event));
    this.paymentIqComponentInstance.destroyed.subscribe(() => {
      this.paymentIqComponentInstance = null;
    });
  }
}
